var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntellectual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2787 20.2858C40.1628 10.7195 32.289 3 22.593 3C12.8247 3 4.90594 10.835 4.90594 20.4999C4.90594 26.2252 7.68477 31.3084 11.9808 34.501V41.6635C11.9808 42.9583 12.8175 44.0894 14.0912 44.3221C15.8392 44.6416 18.6731 44.9997 22.593 44.9997C26.5128 44.9997 29.3468 44.6416 31.0948 44.3221C32.3685 44.0894 33.2052 42.9583 33.2052 41.6635V38.4378L36.0052 38.7841C37.6951 38.9931 39.2199 37.7553 39.3628 36.0586L39.9286 29.3411C41.5998 28.9373 42.8319 28.3528 43.6626 27.853C44.4898 27.3553 44.5882 26.2939 44.0255 25.5094L40.2787 20.2858Z",
    fill: "#D7A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6225 10.4537C11.9583 13.1466 9.86972 18.5874 11.221 23.5505C11.6563 25.1492 13.5365 25.6404 14.9714 24.8119L29.8826 16.2029C31.3175 15.3745 31.8323 13.5006 30.6654 12.3243C27.0429 8.67247 21.2867 7.76086 16.6225 10.4537Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2777 20.2858C40.1619 10.7195 32.2881 3 22.592 3C12.8237 3 4.90497 10.835 4.90497 20.4999C4.90497 26.2252 7.6838 31.3084 11.9798 34.501V41.6635C11.9798 42.9583 12.8165 44.0894 14.0902 44.3221C15.8382 44.6416 18.6722 44.9997 22.592 44.9997C26.5118 44.9997 29.3458 44.6416 31.0938 44.3221C32.3675 44.0894 33.2042 42.9583 33.2042 41.6635V38.4378L36.0042 38.7841C37.6941 38.9931 39.2189 37.7553 39.3618 36.0586L39.9276 29.3411C41.5988 28.9373 42.8309 28.3528 43.6616 27.853C44.4888 27.3553 44.5872 26.2939 44.0245 25.5094L40.2777 20.2858Z",
    stroke: "#61298A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6218 10.4537C11.9576 13.1466 9.86897 18.5874 11.2203 23.5505C11.6555 25.1492 13.5358 25.6404 14.9707 24.8119L29.8819 16.2029C31.3168 15.3745 31.8316 13.5006 30.6647 12.3243C27.0421 8.67247 21.286 7.76086 16.6218 10.4537Z",
    stroke: "#61298A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellectual);
export default __webpack_public_path__ + "static/media/intellectual.3f66b9222523a72af2b9687bdafd0da0.svg";
export { ForwardRef as ReactComponent };